import { createRoot } from "react-dom/client";
import * as Sentry from "@sentry/react";
import App from "./App.tsx";
import "./index.css";
import { OnboardingProvider } from "@/contexts/OnboardingContext";
import { OnboardingTutorial } from "@/components/onboarding/OnboardingTutorial";

Sentry.init({
  dsn: "https://983a98f54eed464ca44e3b9e4943b661@o4510303317852160.ingest.de.sentry.io/4510303372247120",
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
    }),
  ],
  tracesSampleRate: 1.0,
  tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});

createRoot(document.getElementById("root")!).render(
  <OnboardingProvider>
    <App />
    <OnboardingTutorial />
  </OnboardingProvider>
);
